// extracted by mini-css-extract-plugin
export var container = "_dz-1";
export var cornerButtonContainer = "_dz-6";
export var disabled = "_dz-2";
export var dragActive = "_dz-3";
export var fileContainer = "_dz-5";
export var hiddenInput = "_dz-4";
export var widthContainer = "_dz-0";